import { get } from '../httpMethods';
import { ApiResponse } from '../../types/api';
import {
  DashboardKpis,
  RevenueTrend,
  DepartmentStats,
  RecentActivity,
  IncomeExpenseTrend,
  TrendGranularity,
} from '../../types/dashboard';

export const dashboardService = {
  getKpis: (role?: string, dateFrom?: string, dateTo?: string): Promise<ApiResponse<DashboardKpis>> => {
    const params = new URLSearchParams();
    if (role) params.append('role', role);
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);
    return get<DashboardKpis>(`/dashboard/kpis?${params.toString()}`);
  },

  getRevenueTrend: (
    params: { days?: number; dateFrom?: string; dateTo?: string } = {},
  ): Promise<ApiResponse<RevenueTrend>> => {
    const search = new URLSearchParams();
    search.append('days', String(params.days ?? 7));
    if (params.dateFrom) search.append('dateFrom', params.dateFrom);
    if (params.dateTo) search.append('dateTo', params.dateTo);
    return get<RevenueTrend>(`/dashboard/revenue-trend?${search.toString()}`);
  },

  getDepartmentStats: (): Promise<ApiResponse<DepartmentStats>> => {
    return get<DepartmentStats>('/dashboard/department-stats');
  },

  getIncomeExpenseTrend: (
    granularity: TrendGranularity = 'month',
    periods?: number,
  ): Promise<ApiResponse<IncomeExpenseTrend>> => {
    const params = new URLSearchParams();
    params.append('granularity', granularity);
    if (periods) params.append('periods', String(periods));
    return get<IncomeExpenseTrend>(`/dashboard/income-expense-trend?${params.toString()}`);
  },

  getRecentActivity: (limit = 10): Promise<ApiResponse<RecentActivity[]>> => {
    return get<RecentActivity[]>(`/dashboard/recent-activity?limit=${limit}`);
  },
};
